import { render, staticRenderFns } from "./KTCard.vue?vue&type=template&id=6d38b113&scoped=true&"
import script from "./KTCard.vue?vue&type=script&lang=js&"
export * from "./KTCard.vue?vue&type=script&lang=js&"
import style0 from "./KTCard.vue?vue&type=style&index=0&id=6d38b113&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d38b113",
  null
  
)

export default component.exports